import * as React from 'react'

// TODO we need to wait for a fix for SSR issue: https://github.com/bluebill1049/little-state-machine-dev-tools/issues/3
// After we can uncomment the Statemachine provider here and remove it from gatsby-browser.tsx
// <StateMachineProvider>
//   <Component {...(props as P)} />
// </StateMachineProvider>
const withStateMachine =
  <P extends object>(Component: React.ComponentType<P>) =>
  (props: P) =>
    <Component {...(props )} />

export default withStateMachine
